// Feature flag for the entire controller / gamepad subsystem.
//
// When disabled (default): no focus bridge, no SDL SSE connection,
// no virtual keyboard, no on-board reticle, no radial, no text-input
// observer. The app behaves exactly as it did before Phase 1 landed
// Mouse and keyboard only.
//
// Flip via Settings → Controls, or programmatically:
//   setControllerEnabled(true)
//
// The flag is stored in persistentPrefs so it survives dev-port
// changes and app updates. Subscribers are notified on change so the
// app can reconfigure live without a reload (though most wiring only
// re-checks on mount. A reload guarantees a clean state).

import { getPref, setPref } from '../persistentPrefs';
import { isDevBuild } from '../devMode';

export { isDevBuild };

const STORAGE_KEY = 'vk-controller-enabled';

let cached = null;
const listeners = new Set();

export function isControllerEnabled() {
  // Hard gate: shipped (packaged) builds can never turn this on, even
  // if a stored pref says otherwise. The dev URL param is the only
  // way to access the toggle at all.
  if (!isDevBuild()) return false;
  if (cached === null) {
    const stored = getPref(STORAGE_KEY, false);
    cached = stored === true || stored === 'true' || stored === 1;
  }
  return cached;
}

export function setControllerEnabled(next) {
  const v = Boolean(next);
  cached = v;
  setPref(STORAGE_KEY, v);
  for (const fn of listeners) fn(v);
}

export function subscribeControllerEnabled(fn) {
  listeners.add(fn);
  fn(isControllerEnabled());
  return () => listeners.delete(fn);
}

// Test hook.
export function _resetForTest() {
  cached = null;
  listeners.clear();
}
